export default class WebBluetoothEvents {
	public static readonly BLE_PAIR_REQUIRED = 'ble_pair_required';
	public static readonly CONNECTED = 'connected';
	public static readonly CLOSED: 'closed';
	public static readonly DATA = 'data';
	public static readonly DISCONNECTED = 'disconnected';
	public static readonly ERROR = 'error';

	public static get Errors() {
		return {
			CONNECTION_ERROR: 'connection_error',
			SERVICE_ERROR: 'service_error',
			DATA_ERROR: 'data_error',
		};
	}
}
